import { render, staticRenderFns } from "./hotelDetails.vue?vue&type=template&id=151f44ea&"
import script from "./hotelDetails.vue?vue&type=script&lang=ts&"
export * from "./hotelDetails.vue?vue&type=script&lang=ts&"
import style0 from "./hotelDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports